import SystemModalClosingCrossIcon from "../../icons/SystemModalClosingCrossIcon";
import DetailedCourseLevelATaskText from "../../texts/courses/DetailedCourseLevelATaskText";
import DetailedCourseLevelASubthemeText from "../../texts/courses/DetailedCourseLevelASubthemeText";

export default function DetailedCourseScreenHeader({ levelA,
                                                     handleClose }) {
    // Used in DetailedCourseScreen to levelA meta information
    // in header

    // BUILD
    return (
        <div className={"w-full flex justify-start items-start space-x-[12px] px-[16px] py-[12px] border-b-[1px] border-greyLight5 bg-gradient-to-br from-backgroundLight3 to-backgroundLight1"}>
            <div className={"grow flex flex-col justify-start items-start"}>
                <DetailedCourseLevelATaskText task={levelA.task} />
                <DetailedCourseLevelASubthemeText subtheme={levelA?.levelASubtheme?.name} />
            </div>
            <SystemModalClosingCrossIcon onIconPress={handleClose} />
        </div>
    );
}